var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_12326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 1.33325H13.1134C13.4907 1.32658 13.8573 1.45867 14.1436 1.70446C14.43 1.95025 14.6161 2.29262 14.6667 2.66658V7.33325C14.6161 7.70721 14.43 8.04958 14.1436 8.29537C13.8573 8.54116 13.4907 8.67325 13.1134 8.66658H11.3334M6.66669 9.99991V12.6666C6.66669 13.197 6.8774 13.7057 7.25247 14.0808C7.62755 14.4559 8.13625 14.6666 8.66669 14.6666L11.3334 8.66658V1.33325H3.81335C3.4918 1.32961 3.17977 1.44231 2.93475 1.65058C2.68973 1.85884 2.52824 2.14864 2.48002 2.46658L1.56002 8.46658C1.53102 8.65768 1.5439 8.85279 1.59779 9.03841C1.65168 9.22403 1.74529 9.39572 1.87211 9.54157C1.99894 9.68743 2.15597 9.80396 2.33231 9.8831C2.50864 9.96225 2.70008 10.0021 2.89335 9.99991H6.66669Z",
    stroke: "#D55A5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_12326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbs-down.c6382d03ac33a61cd9c36bf6962d76a4.svg";